/* eslint-disable @next/next/no-img-element */
"use client";

import { TextArea } from "@radix-ui/themes";
import { useStreamingVoice } from "../../queries";
import { FullBleedLoading } from "./FullBleedLoading";
import { useEffect } from "react";

const MAX_TEXT_LENGTH = 300;

type SynthInputProps = {
  text: string;
  setText: (text: string) => void;
  state: "ready" | "streaming" | "playing" | "error";
  setState: (state: "ready" | "streaming" | "playing" | "error") => void;
};
export const SynthInput = ({
  text,
  setText,
  state,
  setState,
}: SynthInputProps) => {
  const { data } = useStreamingVoice();

  useEffect(() => {
    const textArea = document.getElementById("syn-text") as HTMLTextAreaElement;
    const resizeObserver = new ResizeObserver((entries) => {
      for (let entry of entries) {
        const { width } = entry.contentRect;
        if (width >= 1000) {
          textArea.rows = 4;
        } else if (width >= 800) {
          textArea.rows = 6;
        } else {
          textArea.rows = 8;
        }
      }
    });

    resizeObserver.observe(document.body);

    return () => {
      resizeObserver.disconnect();
    };
  }, []);

  return (
    <div className="relative self-stretch isolate">
      <label htmlFor="syn-text" className="sr-only">
        Synthesize text
      </label>
      <TextArea
        autoFocus
        value={text}
        onChange={(e) => {
          setText(e.target.value);
        }}
        onFocus={() => {
          if (state === "error") {
            setState("ready");
          }
        }}
        disabled={state === "playing" || state === "streaming"}
        className="self-stretch relative"
        variant="soft"
        size="3"
        maxLength={MAX_TEXT_LENGTH}
        rows={4}
        name="syn-text"
        color="gray"
        id="syn-text"
      />
      {state === "streaming" && (
        <div className="absolute bg-transparent z-10 top-1/3 left-1/2 flex items-center justify-center">
          <FullBleedLoading />
        </div>
      )}
      <div className="bg-[#f0f0f0] flex justify-between items-center gap-4 flex-wrap p-4 md:px-8 rounded-b-lg">
        {data?.name.length > 0 && (
          <div className="rounded-md italic tabular-nums text-gray-700 font-light">
            In the voice of <span className="font-bold">{data?.name}</span>
          </div>
        )}
        <span
          aria-label="Character Count"
          className="ml-auto rounded-md tabular-nums text-gray-700 font-light"
        >
          {text.length}/{MAX_TEXT_LENGTH}
        </span>
      </div>
    </div>
  );
};
